import { styled } from '@mui/material/styles';
import { TableCell, TableRow, TableContainer, Typography, Container, Button } from '@mui/material';

export const AudioSyncContainer = styled(TableContainer)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  padding: '20px',
}));

export const SyncHeading = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: '600',
  lineHeight: '14.63px',
  marginTop: '5px',
}));

export const TranscriptText = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: '600',
  lineHeight: '19.5px',
  color: '#AEAEB2',
  marginTop: '15px',
}));

export const TapText = styled(Typography)(() => ({
  fontSize: 12,
  fontWeight: 600,
  lineHeight: '19.5px',
  marginTop: '5px',
  opacity: '30%',
}));

export const IncorrectText = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: 10,
  lineHeight: '12.19px',
  color: '#E81C0E',
  marginLeft: '5px',
}));

export const CancelButton = styled(Button)(() => ({
  border: '1px solid #E6E6E6',
  borderRadius: '5px',
  width: '82.84px',
  background: 'White',
  color: 'black',
  marginRight: '7px',
  cursor: 'pointer',
}));

export const ValidateButton = styled(Button)(() => ({
  borderRadius: '5px',
  width: '82.84px',
  cursor: 'pointer',
  marginRight: '7px',
  background: 'white',
  color: '#E21824',
  border: '1px solid #E21824',
  '&:hover': {
    background: 'white',
  },
}));

export const ConfirmButton = styled(Button)(() => ({
  borderRadius: '5px',
  width: '82.84px',
  cursor: 'pointer',
  marginRight: '20px',
}));

export const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: 10,
  border: '1px solid #F9F9F9',
  maxHeight: 500,
}));

export const StyledTableHeadRow = styled(TableRow)(() => ({
  '&:first-of-type': {
    backgroundColor: 'grey',
  },
}));

export const StyledTableCellHead = styled(TableCell)(() => ({
  backgroundColor: '#F7F8FB',
  fontSize: 12,
  width: '12.5%',
  '&:first-child': {
    backgroundColor: '#E5E5E5 !important',
    padding: '0px !important',
  },
  '&:last-child': {
    color: '#F7F8FB',
  },
  height: 50,
  padding: '0 !important',
  borderBottom: '1px solid #ddd',
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));

export const StyledTableRow = styled(TableRow)(() => ({
  height: 50,
  padding: '0 !important',
  fontSize: 12,
}));

export const StyledTableCellBody = styled(TableCell)(() => ({
  fontSize: '12px',
  width: '12.5%',
  borderBottom: '1px solid #ddd',
  padding: '0 !important',
}));

export const StyledTypography = styled(Typography)(() => ({
  fontSize: '12px',
  marginLeft: '5px',
}));

export const SuggestionContainer = styled(Container)(() => ({
  overflowY: 'scroll',
  overflowX: 'hidden',
  marginTop: '15px',
  padding: '0px 10px!important',
  height: '450px',
  '&:hover': {
    overflowY: ' auto',
    overflowX: ' auto',
  },
}));

export const SuggestionText = styled(Typography)(() => ({
  fontSize: '16px',
  color: '#AEAEB2',
  lineHeight: '19.5px',
}));
